import { Store } from '@ngxs/store';
import { OnInit, Input, Directive } from '@angular/core';
import { DeleteNotification } from '../notification.state';
import jump from 'jump.js';

@Directive()
export abstract class NotificationBaseComponentDirective implements OnInit {
  loaded = false;
  constructor(private readonly _store: Store) {}

  @Input()
  id: string;

  ngOnInit() {
    this.loaded = true;
  }

  protected scrollToSection(sectionId: string) {
    const section: HTMLElement = document.getElementById(sectionId);
    const middleOfScreen = window.innerHeight / 2;
    jump(section, { offset: -middleOfScreen });
    this.closeNotification();
  }

  protected closeNotification() {
    this._store.dispatch(new DeleteNotification(this.id));
  }
}
